import script from "./ProductToolsBottom.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductToolsBottom.vue?vue&type=script&setup=true&lang=ts"

import "./ProductToolsBottom.scss?vue&type=style&index=0&id=55dcc466&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55dcc466"]])

export default __exports__